<div>
  <p class="mb-4 text-sm text-gray-500">Seja bem-vindo! Adicione abaixo as credencias
    para aceder a sua conta</p>

  <form [formGroup]="this.loginForm" (ngSubmit)="onLogin()">

    <div class="mt-8 mb-2 space-y-8 text-xs">

      <div>
        <app-phone-number-field>
          <app-text-input [formGroup]="loginForm" type="number" id="phoneNumber" [hideCounter]="true" [maxLength]="9"
                          label="Número de telefone"
                          [formError]="errorObject.phoneNumber"></app-text-input>
        </app-phone-number-field>
      </div>

      <!-- password-->
      <div>
        <app-text-input [formGroup]="loginForm" id="password" [hideCounter]="true" [maxLength]="100"
                        type="password" label="Palavra-chave"
                        [formError]="errorObject.password"></app-text-input>
      </div>

    </div>

    <!-- forgot password -->
    <div class="flex mb-2 space-x-1 text-sm">
      <label for="password" class="block  font-medium text-neutral-600">Esqueceu a palavra-chave?</label>
      <a routerLink="recuperar" class="text-blue-500 focus:outline-none focus:underline hover:underline"> Recuperar</a>
    </div>

    <!-- submit button -->
    <div class="mt-6">
      <app-ae-button variant="primary" label="Aceder Conta" type="submit" size="sm"
                styleClass="w-full text-xs"></app-ae-button>
    </div>

  </form>

  <div class="relative my-4">
    <div class="absolute inset-0 flex items-center">
      <div class="w-full border-t border-gray-300"></div>
    </div>
    <div class="relative flex justify-center text-sm">
      <span class="px-2 text-neutral-600 bg-white"> Ou continue com </span>
    </div>
  </div>

  <div #googleButton class="flex justify-center"></div>

  <p class="mt-6 text-sm text-center text-gray-500">Ainda não possui conta?
    <a routerLink="registrar" class="text-blue-500 focus:outline-none focus:underline hover:underline">
      Clique aqui para criar.</a></p>

  <p class="mt-1 text-sm text-center text-gray-500">Não recebeu o SMS de activação?
    <a routerLink="activar" class="text-blue-500 focus:outline-none focus:underline hover:underline">
      Clique aqui para activar.</a></p>
</div>
